import React, { useEffect } from 'react'
import FilterPanel from 'components/Filters/FilterPanel'
import useFiltersManager from 'utils/hooks/useFiltersManager'
import config from 'modules/AccountsMarketplace/Categories/filters'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Typography } from 'gu-ui-kit'
import { DROP_DATA, FETCH_CATEGORIES, SET_FILTERS } from 'modules/AccountsMarketplace/Categories/types'
import { Helmet } from 'react-helmet'
import CategoriesList from './subcomponents/CategoriesList'

const Categories = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { loading, filters, data } = useSelector(
    (state) => state['accounts-marketplace/list'],
  )

  const filterManager = useFiltersManager({
    filters: filters,
    config: config(),
    setAction: SET_FILTERS,
    localStorageKey: 'accounts-marketplace/categories',
  })

  useEffect(() => {
    dispatch({ type: DROP_DATA })
  }, [filterManager.params])

  useEffect(
    () =>
      filterManager.updateConfiguration({
        key: 'category_ids',
        val: {
          options: data.map(({ name, id }) => ({
            value: id,
            label: name,
          })),
        },
      }),
    [data],
  )

  useEffect(
    () =>
      filterManager.params &&
      dispatch({
        type: FETCH_CATEGORIES,
        payload: filterManager.params,
      }),
    [filterManager.params],
  )

  useEffect(() => {
    return () => {
      dispatch({ type: DROP_DATA })
    }
  }, [])

  return (
    <>
      <Helmet defer={false}>
        <title>
          {t('accounts_marketplace::navigation.categories')} —{' '}
          {t('accounts_marketplace::title')}
        </title>
      </Helmet>
      <Typography variant={'Header-60'} className={'margin-bottom-32'}>
        {t('accounts_marketplace::title')}
      </Typography>
      <FilterPanel
        filterManager={filterManager}
        className={'margin-bottom-32'}
      />
      <CategoriesList items={data} loading={loading} />
    </>
  )
}

export default Categories
